<template>
  <div class="about-us">
    <MainImagePreview img-src="about-us/main.png" class="container" />

    <div class="page px-3 mt-5 container">
      <h1 class="custom-title mb-0">Found It!</h1>
      <p class="mt-3">
        We champion the undiscovered so that our creators can publish their
        passion and find new connections in a way that wasn't possible before.
      </p>
    </div>

    <TitleWithBackground
      :lines="['Creative content', 'by anyone, for everyone']"
      variant="secondary"
      class="my-5"
    />

    <div class="page container">
      <Carousel
        id="trendingCreators"
        :items="creators"
        @click="handleCreatorClick"
      >
        <template #title>
          <h2>Trending creators</h2>
        </template>

        <template #itemTitle="{ item }">
          <div v-if="item" class="text-overflow">
            @{{ $get(item, 'profile.handle') }}
          </div>
        </template>

        <template #itemSubtitle="{ item }">
          <span v-if="item">{{ $get(item, 'profile.tagline') }} </span>
        </template>
      </Carousel>

      <Button
        full-width
        class="my-4 about-us__button"
        @click="$router.push('/be-found')"
      >
        Publish your dream book
      </Button>

      <Carousel
        id="recommended"
        class="my-4"
        :items="trendingProducts"
        :mode="CarouselModes.PRODUCT"
        @click="handleProductClick"
      >
        <template #title>
          <h2>Discover books</h2>
        </template>
      </Carousel>

      <h3 class="about-us__yellow-title">Browse our full range</h3>
      <p>
        Whether you want quick and easy recipes, a chance to show off your
        baking, or simply a desire to ace your fitness and diet goals - we have
        hundreds of titles to tickle your tastebuds
      </p>
      <Button
        full-width
        class="mt-4 mb-5 about-us__button"
        @click="$router.push('/products')"
      >
        Find a book for you
      </Button>

      <div class="about-us__social-stars mb-4">
        <img
          class="about-us__social-stars-first"
          src="@/assets/about-us/creator1.png"
          alt="creator1"
          width="200"
          height="250"
        />
        <img
          class="about-us__social-stars-second"
          src="@/assets/about-us/creator2.png"
          alt="creator2"
          width="190"
          height="240"
        />
      </div>

      <h3 class="about-us__yellow-title">By anyone, for everyone</h3>
      <p>
        We know that creators come from all walks of life! There are no rules.
        But the one thing they have in common is their passion.
      </p>
      <Button
        full-width
        class="my-4 about-us__button"
        @click="$router.push('/creators')"
      >
        See our social stars
      </Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from '@/components/Elements/Button';
import MainImagePreview from '@/components/MainImagePreview';
import TitleWithBackground from '@/components/TitleWithBackground';

import {
  fetchCreatorsTrending,
  fetchProductsTrending
} from '@/services/statistics';
import { CarouselModes } from '@/misc/constants';
import filterProductsByRegion from '@/misc/filterProductByRegion';

export default {
  name: 'AboutUs',

  components: {
    Button,
    MainImagePreview,
    TitleWithBackground,
    Carousel: () =>
      import(/* webpackPrefetch: true */ '@/components/Carousel/Index')
  },

  data() {
    return {
      CarouselModes,
      creators: [],
      trendingProducts: []
    };
  },

  head: {
    title: `About Found | Discover today's social creators`,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'Found it! We champion the undiscovered creators and content. Get creative and find books and recipes from the top social stars.'
      }
    ]
  },

  computed: {
    ...mapGetters({
      currency: 'config/currency',
      region: 'config/region'
    })
  },

  mounted() {
    fetchCreatorsTrending(this.$axios).then((response) => {
      this.creators = response.data;
    });
    fetchProductsTrending(this.$axios).then((response) => {
      this.trendingProducts = filterProductsByRegion(
        response.data,
        this.region
      );
    });
  },

  methods: {
    handleCreatorClick(creator) {
      this.$router.push({
        path: `/creators/${
          this.$get(creator, 'profile.handle') ||
          this.$get(creator, 'item.profile.handle') ||
          this.$get(creator, 'id')
        }`
      });
    },
    handleProductClick(params) {
      this.$router.push({ path: `/products/${this.$get(params, 'item.id')}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.about-us {
  &__social-stars {
    margin: 0 auto;
    position: relative;
    height: 300px;
    width: 300px;

    &-first {
      position: absolute;
      left: 0;
      z-index: 1;
    }
    &-second {
      position: absolute;
      top: 40px;
      left: 80px;
      right: 0;
    }
  }

  &__yellow-title {
    color: $secondary-yellow-color;
  }

  &__button {
    max-width: 400px;
    margin: 0 auto;
  }
}
</style>
